export default __webpack_public_path__ + "static/media/head01_zh_tw_pc@2x.27d45523.png";